import { apiSlice } from "../../app/api/apiSlice";

export const sqlApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    forgetPassword: builder.mutation({
      query: ({ username }) => ({
        url: '/forgotPassword/enterEmail',
        method: 'POST',
        body: { username }, 
      }),
    }),
  }),
});

export const { useForgetPasswordMutation } = sqlApiSlice;
